import { makeStyles } from '@material-ui/core/styles'
import { getPixelInREM } from '../../common/material'

const useMenuItemStyles = makeStyles((theme) => ({
    menuItem: {
        display: 'flex',
        cursor: 'pointer',
        paddingTop: getPixelInREM(20),
        '&:before': {
            marginTop: getPixelInREM(10),
            justifySelf: 'stretch',
            minWidth: getPixelInREM(5),
            height: 1,
            backgroundColor: theme.palette.grey[800],
            content: '""'
        },
        '&:hover': {
            color: theme.palette.primary.main,

            '&:before': {
                backgroundColor: theme.palette.primary.main,
                minWidth: getPixelInREM(15)
            }
        }
    },
    itemName: {
        fontSize: getPixelInREM(18),
        fontWeight: 600,
        color: theme.palette.grey[800],
        minHeight: getPixelInREM(16)
    },
    image: {
        float: 'left',
        width: getPixelInREM(16),
        marginRight: getPixelInREM(10),
        marginLeft: getPixelInREM(8),
        minHeight: getPixelInREM(18)
    },
    subMenuItem: {
        display: 'flex',
        cursor: 'pointer',
        paddingTop: getPixelInREM(20),
        fontSize: getPixelInREM(18),
        color: theme.palette.grey[800],
        minHeight: getPixelInREM(18),
        '&:before': {
            marginTop: getPixelInREM(10),
            justifySelf: 'stretch',
            minWidth: getPixelInREM(20),
            height: 1,
            backgroundColor: theme.palette.grey[800],
            content: '""'
        },
        '&:hover': {
            color: theme.palette.primary.main,

            '&:before': {
                backgroundColor: theme.palette.primary.main,
                minWidth: getPixelInREM(30)
            }
        }
    },
    subItemName: {
        marginLeft: getPixelInREM(18)
    },
    active: {
        color: theme.palette.primary.main,
        '&:before': {
            backgroundColor: theme.palette.primary.main
        }
    }
}))

export default useMenuItemStyles
